// Hợp đồng API của module `music` — Kho nhạc (Zod schema + kiểu response).
import { z } from 'zod';
/**
 * Mã thư mục / bài hát do MÁY CHỦ tự sinh: đúng 16 ký tự hex. Đường dẫn file trên đĩa chỉ
 * được ghép từ các mã khớp mẫu này, không bao giờ từ chữ người dùng gửi lên.
 */
export const MUSIC_ID_PATTERN = /^[0-9a-f]{16}$/;
/**
 * Đuôi file được nhận → kiểu MIME khi gửi về. Web dùng để dựng `accept=` của ô chọn file.
 *
 * `zip` thêm 23/09/2026: bước «Hoàn thiện & check» của quy trình sản xuất cần chỗ để hồ sơ bài hát
 * (profile) và bộ stems, mà hai thứ đó luôn là một file nén. Chúng đi chung kho với nhạc vì cùng là
 * file sản phẩm của một bài, cùng hạn ngạch đĩa và cùng luật quyền — dựng một kho riêng chỉ để chứa
 * hai loại file ấy là nhân đôi mọi thứ mà không được gì.
 */
export const MUSIC_MIME_BY_EXTENSION = {
    mp3: 'audio/mpeg',
    m4a: 'audio/mp4',
    aac: 'audio/aac',
    wav: 'audio/wav',
    flac: 'audio/flac',
    ogg: 'audio/ogg',
    opus: 'audio/opus',
    wma: 'audio/x-ms-wma',
    aiff: 'audio/aiff',
    aif: 'audio/aiff',
    alac: 'audio/mp4',
    zip: 'application/zip',
};
/**
 * Tạo và sửa thư mục dùng CHUNG một thân: sửa là thay TRỌN cả ba trường (vì vậy là PUT chứ
 * không phải PATCH) — bỏ trống `note` nghĩa là xoá ghi chú, y như hệ thống cũ.
 * Không đặt `.min(1)` ở đây: câu báo «Chưa đặt tên thư mục» / «Phải chọn một nhóm có thật» do
 * service trả, sau khi đã cắt khoảng trắng.
 */
export const musicFolderInputSchema = z.object({
    name: z.string().max(500).default(''),
    teamId: z.string().max(200).default(''),
    note: z.string().max(5000).default(''),
});
/**
 * `id` trên đường dẫn. Cố ý KHÔNG ép mẫu hex ở đây: mã sai dạng (`../..`, sai độ dài) phải
 * nhận đúng câu 404 «Không có …» như một mã không tồn tại, chứ không phải 400.
 */
export const musicIdParamsSchema = z.object({ id: z.string() });
/** `POST /music/folders/:id/tracks?name=<tên file>` — thân là BYTE THÔ của file. */
export const musicUploadQuerySchema = z.object({ name: z.string().default('') });
/** `PUT /music/tracks/:id` — đổi TÊN HIỂN THỊ của bài; đuôi file giữ nguyên (xem `renamedTrackName`). */
export const musicTrackRenameSchema = z.object({ name: z.string().max(500).default('') });
/** `inline=1` → nghe thử ngay trong trình duyệt; còn lại → tải xuống (attachment). */
export const musicDownloadQuerySchema = z.object({ inline: z.string().optional() });
//# sourceMappingURL=music.js.map